import React from 'react';
import { Box, Typography } from '@mui/material';

export const Stats: React.FC = () => {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Agent Statistics
      </Typography>
      <Typography variant="body1">
        Agent statistics and performance metrics will be displayed here.
      </Typography>
    </Box>
  );
};

export default Stats; 